'use client';
import Lottie, { InteractivityProps, LottieRef } from 'lottie-react';
import {
  AnimationConfigWithData,
  AnimationEventCallback,
  AnimationEventName,
  AnimationEvents,
} from 'lottie-web';
import { HTMLProps,JSX } from 'react';

import animationData from '../../assets/Animations/Json/Gift.json';

export default function GiftAnimation(
  props: JSX.IntrinsicAttributes &
    Omit<AnimationConfigWithData<'svg'>, 'container' | 'animationData'> & {
      lottieRef?: LottieRef;
      onComplete?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onLoopComplete?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onEnterFrame?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onSegmentStart?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onConfigReady?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onDataReady?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onDataFailed?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onLoadedImages?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onDOMLoaded?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
      onDestroy?: AnimationEventCallback<
        AnimationEvents[AnimationEventName]
      > | null;
    } & Omit<HTMLProps<HTMLDivElement>, 'loop'> & {
      interactivity?: Omit<InteractivityProps, 'lottieObj'>;
    },
) {
  return (
    <Lottie
      loop={true}
      style={{ width: 200, height: 200 }}
      {...props}
      animationData={animationData}
    />
  );
}
